import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PhotoUploader from '../PhotoUploader';

const PhotoUpload: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();

  if (!eventId) {
    return <div className="p-6 text-gray-500">No event selected.</div>;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <Link to={`/dashboard/events/${eventId}`} className="mb-4 inline-flex items-center text-sm text-gray-600 hover:text-gray-900">
        <ArrowLeft className="mr-1 h-4 w-4" /> Back to event
      </Link>
      <h1 className="mb-6 text-2xl font-bold text-gray-900">Upload photos</h1>
      <PhotoUploader eventId={eventId} />
    </div>
  );
};

export default PhotoUpload;
